
import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  href?: string;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  variant = 'primary',
  size = 'md',
  className = '',
  disabled = false,
  type = 'button',
  href
}) => {
  const baseClasses = 'whitespace-nowrap cursor-pointer font-medium transition-all duration-300 flex items-center justify-center gap-2';
  
  const variantClasses = {
    primary: 'bg-[#1A4D7C] text-white hover:bg-[#2A5D8C] focus:ring-4 focus:ring-blue-200',
    secondary: 'bg-gray-100 text-gray-900 hover:bg-gray-200 focus:ring-4 focus:ring-gray-200',
    outline: 'border-2 border-[#00D4FF] text-[#00D4FF] hover:bg-[#00D4FF] hover:text-white focus:ring-4 focus:ring-blue-200'
  };

  const sizeClasses = {
    sm: 'px-4 py-2 text-sm rounded-md h-9',
    md: 'px-6 py-3 text-base rounded-full h-12',
    lg: 'px-8 py-4 text-lg rounded-full h-14'
  };

  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className} ${
    disabled ? 'opacity-50 cursor-not-allowed' : ''
  }`;

  if (href) {
    return (
      <a href={href} className={classes}>
        {children}
      </a>
    );
  }

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={classes}
    >
      {children}
    </button>
  );
};
